import type { CalendarEvent } from "@/types/calendar";

export interface MoveValidationContext {
  event: CalendarEvent;
  fromRoomId: string;
  toRoomId: string;
  newStart: Date;
  newEnd: Date;
  eventsAtTarget: CalendarEvent[];
  currentUserEmail?: string;
  currentTime: Date;
}

export interface MoveValidationResult {
  ok: boolean;
  reason?: string;
}

export function isMoveCandidate(event: CalendarEvent, currentUserEmail?: string): boolean {
  if (!event.organizerEmail) {
    console.log(`move_candidate_skip reason=no_organizer_email eventId=${event.id}`);
    return false;
  }
  const domain = event.organizerEmail.split("@")[1]?.toLowerCase();
  if (domain !== "brandazine.com" && domain !== "brandazine.kr") {
    console.log(`move_candidate_skip reason=external_organizer eventId=${event.id} domain=${domain}`);
    return false;
  }
  if (currentUserEmail) {
    console.log(`move_candidate_ok eventId=${event.id} user=${currentUserEmail}`);
  }
  return true;
}

export function validateMove(ctx: MoveValidationContext): MoveValidationResult {
  if (
    ctx.fromRoomId === ctx.toRoomId &&
    ctx.newStart.getTime() === ctx.event.start.getTime() &&
    ctx.newEnd.getTime() === ctx.event.end.getTime()
  ) {
    return { ok: false, reason: "변경 사항 없음" };
  }

  if (!ctx.event.organizerEmail) {
    return { ok: false, reason: "주최자 정보가 없어 이동할 수 없어요" };
  }

  if (ctx.newStart.getTime() < ctx.currentTime.getTime() - 60 * 1000) {
    return { ok: false, reason: "과거 시간으로는 이동할 수 없어요" };
  }

  const overlap = ctx.eventsAtTarget.find(
    (e) => e.id !== ctx.event.id && e.start < ctx.newEnd && e.end > ctx.newStart,
  );
  if (overlap) {
    return { ok: false, reason: `다른 일정과 겹쳐요 (${overlap.summary})` };
  }

  return { ok: true };
}
